module.exports = __webpack_public_path__ + "static/img/1btn1.91f1f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/1btn1.png
// module id = AYJw
// module chunks = 215